// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"ce53992f","953":"7de5bfd1"}[chunkId] + ".chunk.js";
};